const monsters = [
  {
    name: "Hilichurl / Slimes / Spectre",
    res: {
      "Physical RES": 10,
      "Elemental RES": 10
    }
  },
  {
    name: "Mitachurl",
    res: {
      "Physical RES": 30,
      "Elemental RES": 10
    }
  },
  {
    name: "Samachurl",
    res: {
      "Physical RES": 10,
      "Elemental RES": 10
    },
    labels: ["Element"],
    inputTypes: ["variant"],
    inputs: [["Dendro", "Anemo", "Geo", "Hydro", "Cryo", "Electro"]],
    changeRes: ({ target, inputs }) => {
      target[inputs[0] + " RES"] += 40;
    }
  },
  {
    name: "Lawachurl",
    res: {
      "Physical RES": 50,
      "Elemental RES": 10
    },
    labels: ["Element"],
    inputTypes: ["variant"],
    inputs: [["Geo", "Cryo", "Electro"]],
    changeRes: ({ target, inputs }) => {
      target[inputs[0] + " RES"] += 60;
    }
  },
  {
    name: "Ruin Guard / Grader",
    res: {
      "Physical RES": 70,
      "Elemental RES": 10
    }
  },
  {
    name: "Ruin Hunter / Defender / Scout",
    res: {
      "Physical RES": 50,
      "Elemental RES": 10
    }
  },
  {
    name: "Ruin Cruiser / Destroyer",
    res: {
      "Physical RES": 30,
      "Elemental RES": 10
    }
  },
  {
    name: "Perpetual Mechanical Array",
    res: {
      "Physical RES": 70,
      "Elemental RES": 10
    },
    labels: ["Stunned"],
    inputTypes: ["check"],
    inputs: [false],
    changeRes: ({ target, inputs }) => {
      if (inputs[0]) changeAllRes(target, -50);
    }
  },
  {
    name: "Whopperflower",
    res: {
      "Physical RES": 35,
      "Elemental RES": 35
    },
    labels: ["Element", "Stunned"],
    inputTypes: ["variant", "check"],
    inputs: [["Pyro", "Cryo", "Electro"], false],
    changeRes: ({ target, inputs }) => {
      target[inputs[0] + " RES"] += 40;
      if (inputs[1]) changeAllRes(target, -25);
    }
  },
  {
    name: "Regisvine",
    res: {
      "Physical RES": 130,
      "Elemental RES": 110
    },
    labels: ["Element", "Stunned"],
    inputTypes: ["variant", "check"],
    inputs: [["Pyro", "Cryo"], false],
    changeRes: ({ target, inputs }) => {
      target[inputs[0] + " RES"] += 60;
      if (inputs[1]) changeAllRes(target, -100);
    }
  },
  {
    name: "Hypostasis / Maguu Kenki / Dvalin",
    res: {
      "Physical RES": 10,
      "Elemental RES": 10
    }
  },
  {
    name: "Andrius",
    res: {
      "Physical RES": 10,
      "Elemental RES": 10,
      "Anemo RES": Infinity,
      "Cryo RES": Infinity
    }
  },
  {
    name: "Treasure Hoarders",
    res: {
      "Physical RES": -20,
      "Elemental RES": 10
    }
  },
  {
    name: "Nobushi / Kairagi",
    res: {
      "Physical RES": -20,
      "Elemental RES": 10
    }
  },
  {
    name: "Fatui Skirmisher",
    res: {
      "Physical RES": -20,
      "Elemental RES": 10
    },
    labels: ["Armored"],
    inputTypes: ["check"],
    inputs: [false],
    changeRes: ({ target, inputs }) => {
      if (inputs[0]) changeAllRes(target, 100);
    }
  },
  {
    name: "Shadowy Husks",
    res: {
      "Physical RES": 30,
      "Elemental RES": 10
    },
    labels: ["Element"],
    inputTypes: ["variant"],
    inputs: [["Pyro", "Hydro", "Cryo"]],
    changeRes: ({ target, inputs }) => {
      target[inputs[0] + " RES"] += 20;
    }
  },
  {
    name: "Fatui Pyro Agent",
    res: {
      "Physical RES": -20,
      "Elemental RES": 10,
      "Pyro RES": 50
    }
  },
  {
    name: "Fatui Mirror Maiden",
    res: {
      "Physical RES": -20,
      "Elemental RES": 10,
      "Hydro RES": 50
    }
  },
  {
    name: "Fatui Cicin Mage",
    res: {
      "Physical RES": -20,
      "Elemental RES": 10
    },
    labels: ["Element"],
    inputTypes: ["variant"],
    inputs: [["Cryo", "Electro"]],
    changeRes: ({ target, inputs }) => {
      target[inputs[0] + " RES"] += 40;
    }
  },
  {
    name: "Childe",
    res: {
      "Physical RES": 0,
      "Elemental RES": 0
    },
    labels: ["Phase", "Stunned"],
    inputTypes: ["variant", "check"],
    inputs: [["1", "2", "3"], false],
    changeRes: ({ target, inputs }) => {
      if (inputs[0] !== "3") {
        const phase1 = inputs[0] === "1";
        target[(phase1 ? "Hydro" : "Electro") + " RES"] += 50;
        if (inputs[1]) {
          changeAllRes(target, phase1 ? -30 : -50);
        }
      } else {
        target["Hydro RES"] += 70;
        target["Electro RES"] += 70;
      }
    }
  },
  {
    name: "Signora",
    res: {
      "Physical RES": 10,
      "Elemental RES": 10
    },
    labels: ["Phase"],
    inputTypes: ["variant"],
    inputs: [["1", "2"]],
    changeRes: ({ target, inputs }) => {
      if (inputs[0] === "1") {
        target["Cryo RES"] += 40;
      } else {
        target["Pyro RES"] += 60;
      }
    }
  },
  {
    name: "Cicin",
    res: {
      "Physical RES": -50,
      "Elemental RES": 10
    },
    labels: ["Element"],
    inputTypes: ["variant"],
    inputs: [["Cryo", "Electro", "Hydro"]],
    changeRes: ({ target, inputs }) => {
      target[inputs[0] + " RES"] += 40;
    }
  },
  {
    name: "Geovishap Hatchling",
    res: {
      "Physical RES": 30,
      "Elemental RES": 10,
      "Geo RES": 50
    }
  },
  {
    name: "Geovishap",
    res: {
      "Physical RES": 30,
      "Elemental RES": 10,
      "Geo RES": 50
    },
    labels: ["Element", "Infused with Element"],
    inputTypes: ["variant", "check"],
    inputs: [["Pyro", "Hydro", "Cryo", "Electro"], false],
    changeRes: ({ target, inputs }) => {
      if (inputs[1]) target[inputs[0] + " RES"] += 20;
    }
  },
  {
    name: "Primo Geovishap",
    res: {
      "Physical RES": 30,
      "Elemental RES": 10,
      "Geo RES": 50
    },
    labels: ["Element", "Countered (5s)"],
    inputTypes: ["variant", "check"],
    inputs: [["Pyro", "Hydro", "Cryo", "Electro"], false],
    changeRes: ({ target, inputs }) => {
      target[inputs[0] + " RES"] += 20;
      if (inputs[1]) changeAllRes(target, -50);
    }
  },
  {
    name: "Azhdaha",
    res: {
      "Physical RES": 40,
      "Elemental RES": 10,
      "Geo RES": 70
    }
  },
  {
    name: "Abyss Mage / Herald / Lector",
    res: {
      "Physical RES": 10,
      "Elemental RES": 10
    }
  },
  {
    name: "Hydro Mimic",
    res: {
      "Physical RES": 15,
      "Elemental RES": 15,
      "Hydro RES": Infinity
    },
    labels: ["Type"],
    inputTypes: ["variant"],
    inputs: [["Boar/Ferret", "Crane/Raptor", "Crab/Mallard", "Finch/Frog"]],
    changeRes: ({ target, inputs }) => {
      const elmtWeakRes = {
        "Boar/Ferret": "Pyro",
        "Crane/Raptor": "Electro",
        "Crab/Mallard": "Cryo",
        "Finch/Frog": "Geo"
      };
      target[elmtWeakRes[inputs[0]] + " RES"] -= 55;
    }
  },
  {
    name: "The Shogun",
    res: {
      "Physical RES": 10,
      "Elemental RES": 10
    },
    labels: ["State"],
    inputTypes: ["variant"],
    inputs: [["Normal", "Shielded", "Stunned"]],
    changeRes: ({ target, inputs }) => {
      if (inputs[0] !== "Normal")
        changeAllRes(target, inputs[0] === "Shielded" ? 200 : -60);
    }
  },
  {
    name: "False God of Wisdom (Phase 1)",
    res: {
      "Physical RES": 10,
      "Elemental RES": 10,
      "Electro RES": 50
    }
  },
  {
    name: "False God of Wisdom (Phase 2)",
    res: {
      "Physical RES": 30,
      "Elemental RES": 30,
      "Electro RES": 90
    },
    labels: ["State"],
    inputTypes: ["variant"],
    inputs: [["Normal", "Shielded", "Stunned"]],
    changeRes: ({ target, inputs }) => {
      if (inputs[0] !== "Normal")
        changeAllRes(target, inputs[0] === "Shielded" ? 200 : -170);
    }
  },
  {
    name: "Rifthound Whelp",
    res: {
      "Physical RES": 20,
      "Elemental RES": 20
    },
    labels: ["Element", "Enraged"],
    inputTypes: ["variant", "check"],
    inputs: [["Electro", "Geo"], false],
    changeRes: ({ target, inputs }) => {
      if (inputs[1]) {
        target[inputs[0] + " RES"] -= 30;
      }
    }
  },
  {
    name: "Rifthound",
    res: {
      "Physical RES": 25,
      "Elemental RES": 25
    },
    labels: ["Element", "Enraged"],
    inputTypes: ["variant", "check"],
    inputs: [["Electro", "Geo"], false],
    changeRes: ({ target, inputs }) => {
      if (inputs[1]) {
        target[inputs[0] + " RES"] -= 65;
      }
    }
  },
  {
    name: "Golden Wolflord",
    res: {
      "Physical RES": 25,
      "Elemental RES": 25
    },
    labels: ["After Shield Phase"],
    inputTypes: ["check"],
    inputs: [false],
    changeRes: ({ target, inputs }) => {
      if (inputs[0]) {
        target["Geo RES"] -= 45;
      }
    }
  },
  {
    name: "Bathysmal Vishap Hatchling",
    res: {
      "Physical RES": 30,
      "Elemental RES": 10
    },
    labels: ["Element"],
    inputTypes: ["variant"],
    inputs: [["Electro", "Hydro", "Cryo"]],
    changeRes: ({ target, inputs }) => {
      target[inputs[0] + " RES"] += 10;
    }
  },
  {
    name: "Bathysmal Vishaps (boss)",
    res: {
      "Physical RES": 30,
      "Elemental RES": 10
    },
    labels: ["Element"],
    inputTypes: ["variant"],
    inputs: [["Electro", "Cryo"]],
    changeRes: ({ target, inputs }) => {
      target[inputs[0] + " RES"] += 20;
    }
  }
];

export default monsters;

function changeAllRes(target, value) {
  for (let type in target) {
    if (type.substr(-3) === "RES") {
      target[type] += value;
    }
  }
}
